import React from "react";
import { Divider, Flex, Grid, Text } from "@chakra-ui/react";
import useI18nHelper from "@/features/ui/hooks/use-i18n-helper";
import PathPickLandingSection from "@/features/pathpick/features/landing/components/PathPickLandingSection";
import {
  COMPARISON_ROW_KEYS,
  PATHPICK_LANDING_COLORS,
} from "@/features/pathpick/features/landing/constants";

// 기존 소싱 방식 ↔ 패스픽 운영 비교표.
// 좁은 화면에서는 두 칸이 위아래로 쌓이므로 각 칸이 어느 쪽인지 색으로 구분된다.
function PathPickLandingComparisonSection() {
  const { t } = useI18nHelper();

  return (
    <PathPickLandingSection title={t("path_pick_landing:comparison.title")}>
      <Grid
        templateColumns={{ base: "1fr", md: "repeat(2, 1fr)" }}
        columnGap={{ base: "0px", md: "40px" }}
      >
        <Flex flexDirection={"column"}>
          <Text
            textStyle={"body-md-bold"}
            fontSize={"16px"}
            color={PATHPICK_LANDING_COLORS.red}
            paddingBottom={"12px"}
            borderBottom={`2px solid ${PATHPICK_LANDING_COLORS.red}`}
          >
            {t("path_pick_landing:comparison.before_title")}
          </Text>
          {COMPARISON_ROW_KEYS.map((key) => (
            <React.Fragment key={key}>
              <Text
                textStyle={"body-sm-regular"}
                color={PATHPICK_LANDING_COLORS.textBody}
                paddingY={"18px"}
              >
                {t(`path_pick_landing:comparison.rows.${key}.before`)}
              </Text>
              <Divider borderColor={PATHPICK_LANDING_COLORS.divider} />
            </React.Fragment>
          ))}
        </Flex>

        <Flex flexDirection={"column"} marginTop={{ base: "32px", md: "0px" }}>
          <Text
            textStyle={"body-md-bold"}
            fontSize={"16px"}
            color={PATHPICK_LANDING_COLORS.blue}
            paddingBottom={"12px"}
            borderBottom={`2px solid ${PATHPICK_LANDING_COLORS.blue}`}
          >
            {t("path_pick_landing:comparison.after_title")}
          </Text>
          {COMPARISON_ROW_KEYS.map((key) => (
            <React.Fragment key={key}>
              <Text
                textStyle={"body-sm-regular"}
                color={PATHPICK_LANDING_COLORS.textBody}
                paddingY={"18px"}
              >
                {t(`path_pick_landing:comparison.rows.${key}.after`)}
              </Text>
              <Divider borderColor={PATHPICK_LANDING_COLORS.divider} />
            </React.Fragment>
          ))}
        </Flex>
      </Grid>
    </PathPickLandingSection>
  );
}

export default PathPickLandingComparisonSection;
